"use client";
import { useContext, useEffect } from "react";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

const FeaturedPicksWrapper = ({ children }) => {
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  useEffect(() => {
    if (window.location.hash) {
      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        window.scrollTo({ top: isMobileDevice ? 100 : 400, behavior: "smooth" });
      }
    }
  }, []);

  return children;
};

export default FeaturedPicksWrapper;
